import gql from 'graphql-tag';

export const FlagshipFundStrategies = gql`
	query FlagshipStrategiesSection {
		allFlagshipFundStrategiesContent {
			sectionHeading
			sectionSummary
			sectionDisclaimer
			flagshipStrategyShowcase {
				heading
				summary
				strategyStats: stats {
					value
					label
				}
				strategyImages: images {
					asset {
						url
						altText
					}
				}
			}
		}
	}
`;
